import logger from '../common/safe-log';
import EncryptionService from '../services/encryptionService';

const FacebookEventMapping = {

  'Landing Page': {
    fireFacebookEvent: true,
    fbEventName: ['PageView', 'ViewContent'],
    fbQspNameOverride: 'fblp',
  },
  'Presell Page': {
    fireFacebookEvent: true,
    fbEventName: ['PageView', 'ViewContent'],
    fbQspNameOverride: 'fbpp',
  },
  'Splash Page': {
    fireFacebookEvent: true,
    fbEventName: ['PageView', 'ViewContent'],
    fbQspNameOverride: 'fbsp',
  },
  'Select Bundle': {
    fireFacebookEvent: true,
    fbEventName: ['AddToCart'],
    fbQspNameOverride: 'fbatc',
  },
  'Initiate Checkout': {
    fireFacebookEvent: true,
    fbEventName: ['InitiateCheckout'],
    fbQspNameOverride: 'fbic',
  },
  'Shipping Info': {
    fireFacebookEvent: true,
    fbEventName: ['AddPaymentInfo'],
    fbQspNameOverride: 'fbsi',
  },
  'Order Conversion': {
    fireFacebookEvent: true,
    fbEventName: ['Purchase'],
    fbQspNameOverride: 'fboc',
    fbSendValue: true
  },
};

const FacebookStandardEvents = {
  'AddPaymentInfo': {},
  'AddToCart': {},
  'AddToWishlist': {},
  'CompleteRegistration': {},
  'Contact': {},
  'CustomizeProduct': {},
  'Donate': {},
  'FindLocation': {},
  'InitiateCheckout': {},
  'Lead': {},
  'PageView': {},
  'Purchase': {},
  'Schedule': {},
  'Search': {},
  'StartTrial': {},
  'SubmitApplication': {},
  'Subscribe': {},
  'ViewContent': {},
};
const module = 'FacebookTracker';
const FacebookTracker = {
  pixelConfig: null,
  enabled: false,
  load: (pixelId, async = true) => {
    try {

      /* eslint-disable */
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return; n = f.fbq = function () {
                    n.callMethod ?
                        n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                };
                if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                n.queue = []; t = b.createElement(e); t.async = async;
                t.src = v; s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s)
            }(window, document, 'script',
                'https://connect.facebook.net/en_US/fbevents.js');
            if (pixelId) {
                const externalId = EncryptionService.sha256(
                  window?.gu_qs?.listicle_req_id || window?.gu_qs?.externalId || window?.gu_qs?.req_id
                );
                window.fbq('init', pixelId, { external_id: externalId });
                FacebookTracker.enabled = true;
            }
            /* eslint-enable */
    } catch (e) {
      logger.error('load failed', e, { module });
    }
  },
  shouldSendEventToFacebook: (eventName) => {
    return FacebookEventMapping?.[eventName] && FacebookEventMapping[eventName]?.fireFacebookEvent;
  },
  translateFacebookEvent: (eventName, eventConfig) => {
    let fbEventNames = [];
    if (FacebookTracker?.pixelConfig?.[eventConfig.fbQspNameOverride]) {
      fbEventNames.push(FacebookTracker?.pixelConfig?.[eventConfig.fbQspNameOverride]);
    } else if (eventConfig?.fbEventName) {
      fbEventNames = eventConfig?.fbEventName;
    } else {
      fbEventNames.push(eventName);
    }
    return fbEventNames;
  },
  initAdditional: (pixelConfig) => {
    if (!pixelConfig || !pixelConfig?.pixelId) {
      return;
    }
    FacebookTracker.enabled = true;
    FacebookTracker.pixelConfig = pixelConfig;
    try {
      const externalId = EncryptionService.sha256(
        window?.gu_qs?.listicle_req_id || window?.gu_qs?.externalId || window?.gu_qs?.req_id
      );
      window.fbq('init', FacebookTracker.pixelConfig.pixelId, { external_id: externalId });
    } catch (e) {
      logger.error('initAdditional failed', e, { module });
    }
  },
  buildFacebookEventArgs: async (eventProperties, eventConfig) => {
    const eventName = eventProperties.eventName;
    let fbargs = {
      external_id: EncryptionService.sha256(
        eventProperties?.listicle_req_id || eventProperties?.externalId || eventProperties?.req_id
      )
    };

    if (eventConfig.fbSendValue) {
      let value = FacebookTracker.getConversionValue();
      fbargs.value = value;
      fbargs.currency = 'usd';
    }

    fbargs.em = eventProperties?.enhancedConversionData?.email ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.email.toLowerCase()) : '';
    fbargs.ph = eventProperties?.enhancedConversionData?.phone_number ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.phone_number) : '';
    fbargs.fn = eventProperties?.enhancedConversionData?.first_name ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.first_name.toLowerCase()) : '';
    fbargs.ln = eventProperties?.enhancedConversionData?.last_name ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.last_name.toLowerCase()) : '';
    fbargs.ct = eventProperties?.enhancedConversionData?.home_address?.city ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.home_address.city.toLowerCase()) : '';
    fbargs.st = eventProperties?.enhancedConversionData?.home_address?.region ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.home_address.region.toLowerCase()) : '';
    fbargs.country = eventProperties?.enhancedConversionData?.home_address?.country ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.home_address.country.toLowerCase()) : '';
    fbargs.zip = eventProperties?.enhancedConversionData?.home_address?.postal_code ?
      EncryptionService.sha256(eventProperties.enhancedConversionData.home_address.postal_code) : '';
    fbargs.client_ip_address = eventProperties?.ipAddress ? eventProperties.ipAddress : '';

    if (eventName === 'Order Conversion') {
      const order = window?.gu_payments?.order;
      fbargs.order_id = order?.gu_transaction_id;
    }

    // Remove valueless attributes altogether, else FB whines.
    Object.keys(fbargs).forEach((key) => {
      if (fbargs[key] === null || fbargs[key] === undefined || fbargs[key] === '') {
        delete fbargs[key];
      }
    });

    if (eventProperties?.fb_medical === '1') {
      delete fbargs.zip;
    }
    return fbargs;
  },
  trackEvent: async (eventProperties) => {
    try {
      if (!FacebookTracker.enabled) {
        return;
      }
      const eventName = eventProperties.eventName;
      if (!FacebookTracker.shouldSendEventToFacebook(eventName)) {
        return;
      }

      const eventConfig = FacebookEventMapping[eventName];
      let fbEventNames = FacebookTracker.translateFacebookEvent(eventName, eventConfig);

      // Await the async function call
      const fbargs = await FacebookTracker.buildFacebookEventArgs(eventProperties, eventConfig);

      fbEventNames.forEach((fbEventName) => {
        if (FacebookTracker?.pixelConfig?.pixelId) {
          FacebookTracker.trackSingle(FacebookTracker?.pixelConfig?.pixelId, fbEventName, fbargs, eventProperties.eventId);
        } else {
          FacebookTracker.trackSingle(window.fb_id, fbEventName, fbargs, eventProperties.eventId);
        }
      });

      return fbargs;
    } catch (e) {
      logger.error('trackEvent failed', e, { module });
    }
  },
  trackSingle: function (fbid, fbevent, fbargs, eventID) {
    try {
      if (FacebookStandardEvents?.[fbevent]) {
        window.fbq('trackSingle', fbid, fbevent, fbargs, { eventID });
      } else {
        window.fbq('trackSingleCustom', fbid, fbevent, fbargs, { eventID });
      }
    } catch (e) {
      logger.error('trackSingle failed', e, { module });
    }
  },
  getConversionValue: () => {
    try {
      if (FacebookTracker?.pixelConfig?.value) {
        let value = FacebookTracker?.pixelConfig?.value;
        return parseFloat(value.replace('_', '.')).toFixed(2);
      } else {
        return 0.00;
      }
    } catch (e) {
      //console.log(e);
      return 0.00;
    }
  },

};
export default FacebookTracker;